import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitAnswer'
})
export class SplitAnswerPipe implements PipeTransform {

  transform(answer: string, delimiter : string): string[] {
    const splitArr = answer.split(delimiter);

    return splitArr.map((part) => part);
  }

}
